import { gql } from '@apollo/client';

export const AttendeeConnectionFragment = gql`
  fragment AttendeeConnectionFragment on AttendeeConnection {
    createdDate
    requestedDate
    connectedDate
    contactId
    salutation
    firstName
    lastName
    designation
    title
    company
    profileImageUrl
    attendeeId
    id
    canMeet
    visibility
  }
`;

export const SEARCH_ATTENDEE_CONNECTIONS = gql`
  ${AttendeeConnectionFragment}
  query SEARCH_ATTENDEE_CONNECTIONS($criteria: AttendeeConnectionSearchCriteria) {
    searchAttendeeConnections(criteria: $criteria) {
      data {
        ...AttendeeConnectionFragment
      }
      paging {
        currentToken
        nextToken
        previousToken
        limit
        totalCount
      }
    }
  }
`;

export const GET_PENDING_ATTENDEE_CONNECTION_COUNT = gql`
  query GET_PENDING_ATTENDEE_CONNECTION_COUNT {
    getPendingAttendeeConnectionCount {
      pendingCount
    }
  }
`;

export const SEARCH_ATTENDEE_MUTUAL_CONNECTIONS = gql`
  query SEARCH_ATTENDEE_MUTUAL_CONNECTIONS($attendeeId: ID!, $criteria: AttendeeMutualConnectionSearchCriteria) {
    searchAttendeeMutualConnections(attendeeId: $attendeeId, criteria: $criteria) {
      data {
        createdDate
        updatedDate
        contactId
        salutation
        firstName
        lastName
        designation
        title
        company
        profileImageUrl
        attendeeId
        id
        mutual
      }
      paging {
        currentToken
        nextToken
        previousToken
        limit
        totalCount
      }
    }
  }
`;
